import { Col, Container, Row } from "react-bootstrap";

import { Spacer, SpacerHalf } from "./Dividers"

const VIDEOS = ["HXDji0G5cK8", "ASExarBmL1w", "GCN4_Q0kbKA", "rz2p6SRxleU"];

export const Videos = () => {
    return (
        <Container>
            <Spacer />
            <Row>
                {VIDEOS.map((url, index) =>
                    <Col key={index} sm={12} md={6}>
                        <div className="video-container">
                            <iframe
                                width="100%"
                                height="100%"
                                src={"https://www.youtube-nocookie.com/embed/" + url + "?hl=en&rel=0"}
                                title={"YouTube Player " + index}
                                frameborder="0"
                                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin"
                                allowfullscreen />
                        </div>
                        <SpacerHalf />
                    </Col>
                )}
            </Row>
            <SpacerHalf />
        </Container>
    );
}